<script lang="ts">
import { createElementId } from '@/modules/form'

type Props = {
	name: string
	value: boolean
	disabled?: boolean
	testId: string
	onChange?: (e: Event) => void
}

let { name, value = $bindable(), disabled = false, onChange, testId }: Props = $props()

const id = `switch-${createElementId()}`

const handleChange = (e: Event) => {
	onChange && onChange(e)
}
</script>

<label for={id} class="inline-flex relative items-center cursor-pointer">
	<input
		type="checkbox"
		{value}
		{id}
		{name}
		class="sr-only peer"
		{disabled}
		onchange={handleChange}
		bind:checked={value}
		data-testid={`${testId}Switch`}
	/>
	<div class={['switch', value && 'checked']}></div>
</label>

<style lang="postcss">
.switch {
	@apply w-11 h-6 bg-gray-200 rounded-full transition-colors;
}
.switch:focus {
	@apply outline-none;
}
.switch:after {
	@apply absolute content-[""] left-[2px] top-[2px] h-5 w-5 rounded-full border border-gray-300 transition-transform bg-neutral-100;
}
.switch.checked {
	@apply bg-primary-button;
}
.switch.checked:after {
	@apply translate-x-full bg-neutral-100;
}
</style>
